<template>
	<div class="tusd-wrap wrap-bg">
		<cube-scroll-nav-bar :current="currentStatus" :labels="status" :txts="txts" @change="changeNav" />
		<div class="separator"></div>
		<div class="search">
			<div class="search_item">
				<cube-select @change="getOrders(1)" v-model="searchForm.payType" placeholder="请选择支付方式"
					:options="payTypeOptions">
				</cube-select>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.payName" placeholder="打款人" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input type="number" v-model="searchForm.minCNY" placeholder="最小金额（CNY）"
					@change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input type="number" v-model="searchForm.maxCNY" placeholder="最大金额（CNY）"
					@change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.startTime" readonly placeholder="订单开始时间"
					@focus="startDatePicker()"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.endTime" readonly placeholder="订单结束时间"
					@focus="endDatePicker()"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.orderNo" placeholder="系统/商户订单号" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-input v-model="searchForm.bankRemark" placeholder="收款人备注" @change="getOrders(1)"></cube-input>
			</div>
			<div class="search_item">
				<cube-multi-select v-model="searchForm.bankGroupIds" :options="bankGroupOptions" placeholder="收款方式分组"
					title="请选择" @change="getOrders(1)" />
			</div>
			<div class="search_item">
				<div class="search-form-btn-small" @click="exportExcel">导出账单</div>
			</div>
		</div>
		<cube-slide class="order-scroll" :options="{ click: false }" :showDots="false" :initialIndex="crtIndex"
			:autoPlay="false" :loop="false" @change="changeSlide">
			<cube-slide-item>
				<cube-scroll ref="scrollF" :data="orderF" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<order-item v-for="o in orderF" :order="o" :index="0" :searchForm="searchForm"></order-item>
						<div class="order-noData" v-if="orderF.length < 1">暂无待处理订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollS" :data="orderS" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<order-item v-for="o in orderS" :order="o" :index="1" :searchForm="searchForm"></order-item>
						<div class="order-noData" v-if="orderS.length < 1">暂无已完成订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollT" :data="orderT" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<order-item v-for="o in orderT" :order="o" :index="2" :searchForm="searchForm"></order-item>
						<div class="order-noData" v-if="orderT.length < 1">暂无异议订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollR" :data="orderR" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<order-item v-for="o in orderR" :order="o" :index="3" :searchForm="searchForm"></order-item>
						<div class="order-noData" v-if="orderR.length < 1">暂无退返订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll ref="scrollFO" :data="orderFO" :options="scrollOptions" @pulling-down="refreshData"
					@pulling-up="loadMoreData">
					<div class="order-list my-order">
						<order-item v-for="o in orderFO" :order="o" :index="4" :searchForm="searchForm"></order-item>
						<div class="order-noData" v-if="orderFO.length < 1">暂无订单</div>
					</div>
				</cube-scroll>
			</cube-slide-item>
		</cube-slide>
	</div>
</template>

<script>
import orderItem from "@/components/orderItem.vue"
import CubeMultiSelect from "@/components/CubeMultiSelect.vue"
export default {
	name: 'order',
	data() {
		return {
			currentStatus: 1,
			crtIndex: 0,
			status: [1, 3, 2, 6, 0],
			txts: ['待处理', '已完成', '异议', '退返', '全部'],
			orderDesc: ["F", "S", "T", "R", "FO"],
			scrollOptions: this.$store.state.refreshOptions,
			orderF: [],
			orderS: [],
			orderT: [],
			orderFO: [],
			orderR: [],
			pageF: 1,
			pageS: 1,
			pageT: 1,
			pageFO: 1,
			pageR: 1,
			payTypeOptions: [
				{
					value: -1,
					text: '全部'
				},
				{
					value: 1,
					text: '银行卡'
				},
				{
					value: 2,
					text: '支付宝'
				},
			],
			bankGroupOptions: [],
			searchForm: {
				payType: -1,
				payName: '',
				minCNY: '',
				maxCNY: '',
				startTime: '',
				endTime: '',
				orderNo: '',
				bankRemark: '',
				bankGroupIds: []
			}
		}

	},
	components: {
		orderItem: orderItem,
		CubeMultiSelect
	},
	methods: {
		startDatePicker() {
			if (!this.startTimeDatePicker) {
				this.startTimeDatePicker = this.$createDatePicker({
					title: '请选择开始时间',
					min: new Date(2023, 1, 1),
					max: new Date(2030, 12, 31),
					value: new Date(),
					onSelect: this.startSelectHandle,
					onCancel: this.startCancelHandle
				})
			}
			this.startTimeDatePicker.show()
		},
		startSelectHandle(date, selectedVal, selectedText) {
			var startTime = selectedText[0] + '-' + selectedText[1] + '-' + selectedText[2];
			this.searchForm.startTime = startTime;
			this.getOrders(1);
		},
		startCancelHandle() {
			this.searchForm.startTime = ''
		},
		endDatePicker() {
			if (!this.endTimeDatePicker) {
				this.endTimeDatePicker = this.$createDatePicker({
					title: '请选择结束时间',
					min: new Date(2023, 1, 1),
					max: new Date(2030, 12, 31),
					value: new Date(),
					onSelect: this.endSelectHandle,
					onCancel: this.endCancelHandle
				})
			}
			this.endTimeDatePicker.show()
		},
		endSelectHandle(date, selectedVal, selectedText) {
			var endTime = selectedText[0] + '-' + selectedText[1] + '-' + selectedText[2];
			this.searchForm.endTime = endTime;
			this.getOrders(1);
		},
		endCancelHandle() {
			this.searchForm.endTime = ''
		},
		refreshSearch() {
			this.searchForm = {
				payType: -1,
				payName: '',
				minCNY: '',
				maxCNY: '',
				startTime: '',
				endTime: '',
				orderNo: '',
				bankRemark: '',
				bankGroupId: ''
			}
		},
		changeNav(sta) {
			this.status.some((v, i) => {
				if (v == sta) {
					this.crtIndex = i
					return true
				}
			})
			if (sta == 2) {
				this.txts = ['待处理', '已完成', '异议', '退返', '全部']
			}
		},
		changeSlide(idx) {
			let that = this;
			//设置当前的Status值
			that.currentStatus = that.status[idx];
			var type = that.getType();
			if (!that["hasSend" + type])//没有发送请求就发送
			{
				that.getOrders();
				that["hasSend" + type] = true;
			}

		},
		getType() {
			let that = this
			return that.orderDesc[that.crtIndex];
		},
		setParam() {//设置请求参数
			let that = this;
			let cstatus = that.status[that.crtIndex];
			var param = {
				pageSize: 10,
				type: cstatus
			}
			return param;
		},
		getOrders(refreshPage) {
			let that = this;
			let type = that.getType();
			that['page' + type] = that['page' + type] ? that['page' + type] : 1;//存储不同页面的页码
			let data = that.setParam();
			if (refreshPage == 1) {
				data["pageIndex"] = 1;  //设置当前页面的页码参数
				that.orderF = []
				that.orderS = []
				that.orderT = []
				that.orderR = []
				that.orderFO = []
			} else {
				data["pageIndex"] = that['page' + type];  //设置当前页面的页码参数
			}
			if (that.searchForm.payType !== -1) {
				data["payType"] = that.searchForm.payType
			}
			if (that.searchForm.minCNY) {
				data["minCNY"] = Number(that.searchForm.minCNY)
			}
			if (that.searchForm.maxCNY) {
				data["maxCNY"] = Number(that.searchForm.maxCNY)
			}
			if (that.searchForm.payName) {
				data["payName"] = that.searchForm.payName
			}
			if (that.searchForm.startTime) {
				data["startTime"] = that.searchForm.startTime
			}
			if (that.searchForm.endTime) {
				data["endTime"] = that.searchForm.endTime
			}
			if (that.searchForm.orderNo) {
				data["orderNo"] = that.searchForm.orderNo
			}
			if (that.searchForm.bankRemark) {
				data["bankRemark"] = that.searchForm.bankRemark
			}
			if (that.searchForm.bankGroupIds && that.searchForm.bankGroupIds.length > 0) {
				data["bankGroupIds"] = that.searchForm.bankGroupIds;
			}
			// data["minCNY"] = Number(that.searchForm.minCNY)
			// data["maxCNY"] = Number(that.searchForm.maxCNY)

			this.$api.getOrders(data).then((res) => {
				var data = res.data
				//后台传过来页码要存储在  that['page'+type] 之中
				that['order' + type] = that['order' + type].concat(data.Items);
				if (that['page' + type] > data.TotalPages) {
					that.$refs['scroll' + type].forceUpdate();
				} else {
					that['page' + type]++;
				}
			})
		},
		exportExcel() {
			let that = this;

			let data = that.setParam();
			if (that.searchForm.payType !== -1) {
				data["payType"] = that.searchForm.payType
			}
			if (that.searchForm.minCNY) {
				data["minCNY"] = Number(that.searchForm.minCNY)
			}
			if (that.searchForm.maxCNY) {
				data["maxCNY"] = Number(that.searchForm.maxCNY)
			}
			if (that.searchForm.payName) {
				data["payName"] = that.searchForm.payName
			}
			if (that.searchForm.startTime) {
				data["startTime"] = that.searchForm.startTime
			}
			if (that.searchForm.endTime) {
				data["endTime"] = that.searchForm.endTime
			}
			if (that.searchForm.orderNo) {
				data["orderNo"] = that.searchForm.orderNo
			}
			if (that.searchForm.bankRemark) {
				data["bankRemark"] = that.searchForm.bankRemark
			}
			if (that.searchForm.bankGroupIds && that.searchForm.bankGroupIds.length > 0) {
				data["bankGroupIds"] = that.searchForm.bankGroupIds;
			}
			data["export"] = 1;
			this.$api.getOrders(data).then((res) => {
				this.$message.popup(res.msg, 2000);
			})
		},
		getErrorOrdersNum() {//获取异常订单
			let that = this;
			that.$api.getErrorOrders(1).then((res) => {
				let num = res.data;
				if (num > 0) {
					that.txts = ['待处理', '已完成', '异议<span class="tip">' + num + '<span>', '退返', '全部']
				}
			})
		},
		refreshData() {
			this.getOrders();
		},
		loadMoreData() {
			this.getOrders();
		},
		getUserBankGroupList() {
			let that = this;
			this.$api.getUserBankGroups().then((res) => {
				that.bankGroupOptions = res.data.map(v => ({ text: v.Title, value: v.Id }));
			});
		}
	},
	created() {
		let that = this;
		that.getErrorOrdersNum();
		that.$parent.active = that.$store.state.routerStore.menu.active;
		that.crtIndex = that.$route.params.crtIndex ? that.$route.params.crtIndex : that.crtIndex;
		that.currentStatus = that.status[that.crtIndex];
		if (that.$store.state.routerStore.orderDetails) {
			that.searchForm = that.$store.state.routerStore.orderDetails.searchForm
		}

		var type = that.getType();
		that.getOrders();
		that["hasSend" + type] = true;
		this.getUserBankGroupList();
	}
}
</script>

<style lang="less">
* {
	.tip {
		position: absolute;
		top: 5px;
		font-size: 10px !important;
		border-radius: 100%;
		/* padding: 3px; */
		background: red;
		color: #fff;
		margin-left: 5px;
		display: inline;
		width: 20px;
		height: 20px;
		line-height: 18px;
		text-align: center;
	}

	.search {
		background: #222946;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-around;

		.search_item {
			width: 48%;
			margin-bottom: 10px;

			.cube-select,
			.cube-input {
				background: #222946;
				color: #d9e3fd;
			}

			.cube-input-field {
				color: #d9e3fd;
				padding: 5px 10px;
			}

			.cube-select {
				padding: 5px 10px;
				border: none;
			}

			.cube-select::after,
			.cube-input::after {
				border-radius: 15px;
			}

			.search-form-btn-small {
				line-height: 30px;
				width: 100%;
				padding: 0px 10px;
				border-radius: 10px;
				background-color: #00a0de;
				color: #fff;
				text-align: center;
			}
			
		}
	}
}
</style>
